import { render, staticRenderFns } from "./403.vue?vue&type=template&id=97f77f98&scoped=true&"
import script from "./403.vue?vue&type=script&lang=ts&"
export * from "./403.vue?vue&type=script&lang=ts&"
import style0 from "./403.vue?vue&type=style&index=0&id=97f77f98&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97f77f98",
  null
  
)

export default component.exports